var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.hasAnyRole("ROLE_ATMANAGE")
      ? _c(
          "div",
          { staticClass: "col-md-10 pt-3" },
          [
            _c("toast", { ref: "toast" }),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table table-bordered table-responsive" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.companyList, function(result, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.pagination.currentPage * _vm.dispMaxSize +
                              index +
                              1
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "noflap" }, [
                        _c("span", { staticClass: "noflap" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "/atmanage/company/report/" + result.uuid
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(result.companyName) +
                                  "\n                      "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "noflap" }, [
                        _vm._v(_vm._s(result.domain))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("date")(result.createdAt)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("between")(result.createdAt)))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "text-align": "right" } }, [
                        _vm._v(_vm._s(result.report.userCount))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            result.report.plan == 0 ? "ノーマル" : "エラー"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("yen")(result.report.userCount * 100)) +
                            "円"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info btn-sm",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.clickLink(result.id)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-cloud-download-alt fa-1x",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  color: "white",
                                  "text-decoration": "none"
                                },
                                attrs: { id: "download_" + result.id }
                              },
                              [_vm._v("従業員一覧")]
                            )
                          ]
                        )
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("No")]),
        _vm._v(" "),
        _c("th", [_vm._v("会社名")]),
        _vm._v(" "),
        _c("th", [_vm._v("ドメイン")]),
        _vm._v(" "),
        _c("th", [_vm._v("登録日")]),
        _vm._v(" "),
        _c("th", [_vm._v("契約期間")]),
        _vm._v(" "),
        _c("th", [_vm._v("今月契約数")]),
        _vm._v(" "),
        _c("th", [_vm._v("プラン")]),
        _vm._v(" "),
        _c("th", [_vm._v("請求（とりあえず100円計算）")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0785cf68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0785cf68","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/atmanage/company/CompanyList.vue
// module id = 377
// module chunks = 0